/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { Settings } from "./Settings";
import {
  SettingsFromJSON,
  SettingsFromJSONTyped,
  SettingsToJSON,
  SettingsToJSONTyped,
} from "./Settings";
import type { Result } from "./Result";
import { ResultFromJSON, ResultFromJSONTyped, ResultToJSON, ResultToJSONTyped } from "./Result";

/**
 * A custom serializer to handle serialize difficult
 * fields - like model_revision.
 * @export
 * @interface PostProcessingOverview
 */
export interface PostProcessingOverview {
  /**
   *
   */
  readonly username?: string;
  /**
   *
   */
  readonly externalUserId?: string | null;
  /**
   *
   */
  readonly metadataVersion?: number;
  /**
   *
   */
  readonly startTimeSim?: Date;
  /**
   *
   */
  readonly endTimeSim?: Date;
  /**
   *
   */
  results: Result;
  /**
   *
   */
  settings: Settings;
  /**
   *
   */
  readonly modelName?: string;
  /**
   *
   */
  readonly simulationName?: string;
  /**
   * Scenario name for saving the results
   */
  readonly scenarioName?: string;
  /**
   *
   */
  readonly modelId?: number;
  /**
   *
   */
  readonly modelRevisionId?: string;
  /**
   *
   */
  readonly email?: string;
  /**
   *
   */
  readonly resultUuid?: string;
  /**
   *
   */
  readonly organisationUuid?: string;
  /**
   *
   */
  readonly simulation?: number;
}

/**
 * Check if a given object implements the PostProcessingOverview interface.
 */
export function instanceOfPostProcessingOverview(value: object): value is PostProcessingOverview {
  if (!("results" in value) || value["results"] === undefined) return false;
  if (!("settings" in value) || value["settings"] === undefined) return false;
  return true;
}

export function PostProcessingOverviewFromJSON(json: any): PostProcessingOverview {
  return PostProcessingOverviewFromJSONTyped(json, false);
}

export function PostProcessingOverviewFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PostProcessingOverview {
  if (json == null) {
    return json;
  }
  return {
    username: json["username"] == null ? undefined : json["username"],
    externalUserId:
      json["external_user_id"] === undefined
        ? undefined
        : json["external_user_id"] === null
        ? null
        : json["external_user_id"],
    metadataVersion: json["metadata_version"] == null ? undefined : json["metadata_version"],
    startTimeSim:
      json["start_time_sim"] == null ? undefined : parseDateTime(json["start_time_sim"]),
    endTimeSim: json["end_time_sim"] == null ? undefined : parseDateTime(json["end_time_sim"]),
    results: ResultFromJSON(json["results"]),
    settings: SettingsFromJSON(json["settings"]),
    modelName: json["model_name"] == null ? undefined : json["model_name"],
    simulationName: json["simulation_name"] == null ? undefined : json["simulation_name"],
    scenarioName: json["scenario_name"] == null ? undefined : json["scenario_name"],
    modelId: json["model_id"] == null ? undefined : json["model_id"],
    modelRevisionId: json["model_revision_id"] == null ? undefined : json["model_revision_id"],
    email: json["email"] == null ? undefined : json["email"],
    resultUuid: json["result_uuid"] == null ? undefined : json["result_uuid"],
    organisationUuid: json["organisation_uuid"] == null ? undefined : json["organisation_uuid"],
    simulation: json["simulation"] == null ? undefined : json["simulation"],
  };
}

export function PostProcessingOverviewToJSON(json: any): PostProcessingOverview {
  return PostProcessingOverviewToJSONTyped(json, false);
}

export function PostProcessingOverviewToJSONTyped(
  value?: Omit<
    PostProcessingOverview,
    | "username"
    | "externalUserId"
    | "metadataVersion"
    | "startTimeSim"
    | "endTimeSim"
    | "modelName"
    | "simulationName"
    | "scenarioName"
    | "modelId"
    | "modelRevisionId"
    | "email"
    | "resultUuid"
    | "organisationUuid"
    | "simulation"
  > | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    results: ResultToJSON(value["results"]),
    settings: SettingsToJSON(value["settings"]),
  };
}
